document.addEventListener('klaviyoForms', function(e) {
  if (e.detail.type !== 'submit') return;

  var email = (e.detail.metaData && e.detail.metaData.$email)
    ? e.detail.metaData.$email
    : '';

  // publish() is a Shopify global — bridges main page → Custom Pixel sandbox
  if (typeof publish === 'function') {
    publish('newsletter_signup', { email: email });
  }
});